import React from 'react'

function ShowError({ text, className }) {
    return (
        <span className={`${className} my-1 text-danger`}>{text} </span>
    )
}

export default ShowError